<template>
  <div class="home">
    <div class="login bs">
      <h3 class="title">八大员系统</h3>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" center>
        <el-form-item label="用户名：" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input type="password" v-model="form.password" autocomplete="new-password" clearable></el-input>
        </el-form-item>
        <el-form-item class="bot">
          <el-button type="primary" @click="login">登录</el-button>
          <div class="enter flex">
            <span class="cur" @click="forgetPop">忘记密码?</span>
            <span class="cur" @click="loginPop">个人注册</span>
          </div>
        </el-form-item>
      </el-form>
      <el-row>
        <el-button type="primary" plain>机构一</el-button>
        <el-button type="primary" plain>机构二</el-button>
        <el-button type="primary" plain>机构三</el-button>
        <el-button type="primary" plain>机构四</el-button>
        <el-button type="primary" plain>机构五</el-button>
      </el-row>
      <el-row style="margin-top:10px">
        <el-button type="primary" plain>机构六</el-button>
        <el-button type="primary" plain>机构七</el-button>
        <el-button type="primary" plain>机构八</el-button>
        <el-button type="primary" plain>机构九</el-button>
        <el-button type="primary" plain>机构十</el-button>
      </el-row>
    </div>
    <!-- 忘记密码弹框 -->
    <el-dialog title="忘记密码" :visible.sync="forgetDialog" width="30%" center>
      <el-form
        class="info"
        ref="forgetForm"
        :model="forgetForm"
        :rules="forgetRule"
        label-width="100px"
      >
        <el-form-item label="姓名：">
          <el-input v-model="forgetForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：">
          <el-input v-model="forgetForm.card" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="forgetForm.newpsd" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：">
          <el-input v-model="forgetForm.surepsd" placeholder="请输入确认密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号：">
          <el-input v-model="forgetForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          <el-input v-model="forgetForm.code" placeholder="请输入验证码"></el-input>
        </el-form-item>
        <el-form-item class="create">
          <el-button type="primary" @click="login">提交</el-button>
          <el-button type="primary" plain @click="forgetDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 个人注册 -->
    <el-dialog title="个人注册" :visible.sync="loginDialog" width="50%" center>
      <el-form class="info" ref="loginForm" :model="loginForm" label-width="100px">
        <el-form-item label="本人照片：">
          <!-- <el-input v-model="form.name"></el-input> -->
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            v-model="form.photo"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">请上传jpg, gif, png格式的图片, 建议图片大小不超过2M，比例为1:1</div>
          </el-upload>
        </el-form-item>
        <div class="line">
          <el-form-item class="fl" label="姓名：">
            <el-input v-model="loginForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item class="sex fl" label="性别：">
            <el-radio v-model="loginForm.sex" label="1">男</el-radio>
            <el-radio v-model="loginForm.sex" label="2">女</el-radio>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="身份证号：">
            <el-input v-model="loginForm.card" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="所属企业：">
            <el-input v-model="loginForm.company" placeholder="请输入企业名称"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="手机号：">
            <el-input v-model="loginForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="loginForm.code" placeholder="请输入验证码"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="选择专业：">
            <el-select v-model="loginForm.special" placeholder="请选择专业">
              <el-option label="建筑工程" value="shanghai"></el-option>
              <el-option label="室内设计" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item class="create">
          <el-button type="primary" @click="loginDialog = false">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-dialog title="个人注册" :visible.sync="loginDialog" width="50%" center>
      <el-form class="info" ref="loginForm" :model="loginForm" label-width="100px">
        <el-form-item label="本人照片：">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            v-model="form.photo"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">请上传jpg, gif, png格式的图片, 建议图片大小不超过2M，比例为1:1</div>
          </el-upload>
        </el-form-item>
        <div class="line">
          <el-form-item class="fl" label="姓名：">
            <el-input v-model="loginForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item class="sex fl" label="性别：">
            <el-radio v-model="loginForm.radio" label="1">男</el-radio>
            <el-radio v-model="loginForm.radio" label="2">女</el-radio>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="身份证号：">
            <el-input v-model="loginForm.name" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="所属企业：">
            <el-input v-model="loginForm.name" placeholder="请输入企业名称"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="手机号：">
            <el-input v-model="loginForm.name" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="loginForm.name" placeholder="请输入验证码"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="选择专业：">
            <el-select v-model="loginForm.region" placeholder="请选择专业">
              <el-option label="建筑工程" value="shanghai"></el-option>
              <el-option label="室内设计" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item class="create">
          <el-button type="primary" @click="loginDialog=false">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>-->
  </div>
</template>

<script>
export default {
  name: "system",
  components: {},
  data() {
    return {
      forgetDialog: false,
      loginDialog: false,
      imageUrl: "",
      form: {
        name: "",
        password: ""
      },
      forgetForm: {
        name: "",
        card: "",
        newpsd: "",
        surepsd: "",
        phone: "",
        code: ""
      },
      loginForm: {
        name: "",
        sex: "1",
        card: "",
        company: "",
        phone: "",
        code: "",
        special: ""
      },
      rules: {
        // name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
      },
      forgetRule: {
        // name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
      }
    };
  },
  methods: {
    login() {
      this.$router.push({
        path: "/systemHome"
      });
    },
    forgetPop() {
      this.forgetDialog = true;
    },
    loginPop() {
      this.loginDialog = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader {
  position: relative;
}
.el-upload__tip {
  font-size: 14px;
  line-height: 30px;
  position: absolute;
  left: 150px;
  top: 50%;
  transform: translateY(-100%);
}
// .el-form{
//   width: 70%;
//   margin: 10px auto;
// }
.home {
  // width: 100%;
  // height: 100%;
  background: url("../assets/images/bg.jpg") no-repeat center;
  background-size: cover;
  position: relative;
  .login {
    width: 520px;
    height: 430px;
    padding: 30px;
    background: #ffffff;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .title {
      text-align: center;
      margin-bottom: 20px;
    }
  }
  .bot {
    /deep/.el-form-item__content {
      text-align: center;
      margin-left: 0 !important;
    }
    /deep/.el-button--primary {
      width: 60%;
    }
  }
  .enter {
    width: 60%;
    margin: auto;
    span {
      color: #409eff;
      text-decoration: underline;
      transition: 0.3s;
      &:hover {
        color: #66b1ff;
      }
    }
  }
}
.info {
  padding: 0 20px;
  .line {
    .sex {
      /deep/.el-radio {
        width: 20%;
        float: left;
      }
    }
    /deep/.el-form-item {
      width: 44%;
      // float: left;
      display: inline-block;
      margin-right: 50px;
    }
    /deep/.el-form-item__label {
      font-size: 16px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .create {
    display: block;
    /deep/.el-form-item__content {
      text-align: center;
      margin-top: 30px;
    }
    /deep/.el-button--primary {
      width: 30%;
    }
  }
}
</style>
